module.exports = __webpack_public_path__ + "static/government-office-22a6a24f31b60bc7e7bf7071d5da5cf4.jpg";